import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { stepContent, header, singleInput } from "../../style";
import SeeMore from "../../../shared/SeeMore";
import { useNewOfferMobile } from "../../../context";
import InputCreditCard from "../../../../../../shared/atoms/InputCreditCard";

const CreditCardNumberInput = ({ step, creditCardData, onChangeCreditCardData }) => {
	const { setStepError } = useNewOfferMobile();

	const [activeBrand, setActiveBrand] = useState(undefined);
	const [state, setState] = useState({
		cardNumber: creditCardData.data.cardNumber || "",
		hasError: false
	});

	useEffect(() => {
		setStepError(!state.cardNumber.length);
	}, [state]);

	const onChange = (event, details) => {
		const { value } = event.target;
		const cardNumber = String(value).replace(/[^0-9.]/g, "");

		setState({
			...state,
			cardNumber,
			hasError: !activeBrand || !details || !details.lengths.find(l => l === cardNumber.length)
		});

		onChangeCreditCardData({ cardNumber: cardNumber, details });
	};

	return (
		<div
			className={css`
				${stepContent};
			`}
		>
			<strong
				className={css`
					${header};
				`}
			>
				Dados do cartão
			</strong>
			<div
				className={css`
					${singleInput};
				`}
			>
				<InputCreditCard
					name="cardNumber"
					id="cardNumber"
					value={state.cardNumber}
					onChange={onChange}
					placeholder=""
					label="Número do cartão"
					errorMessage="Número inválido"
					maxLength={30}
					hasError={state.hasError}
					data-action="register-credit-card-number"
					getActiveBrand={activeBrand => setActiveBrand(activeBrand)}
				/>
			</div>

			<SeeMore>
				<strong>Por que precisamos dos dados do seu cartão?</strong>
				<p>
					Para emitir passagens em companhias internacionais, o pagamento das taxas e encargos deve
					ser feito no cartão de crédito do mesmo titular das milhas.                 
				</p>

				<p>Por isso, cadastre os dados corretos do cartão.</p>

				<p>
					<strong>Sigilo e segurança dos seus dados</strong>
				</p>

				<p>
					Vale sempre lembrar que nossa plataforma é blindada e tem certificação de excelência em
					segurança. Aqui, seus dados estão protegidos.
				</p>
			</SeeMore>
		</div>
	);
};

export default CreditCardNumberInput;
